import Input from '../../common/Input';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Checkbox from '../../common/Checkbox';
import Label from '../../common/Label';
import SelectSearch from '../../common/SelectSearch';
import Choice from '../../common/Choice';
import Card from '../../common/Card';
import { useDispatch, useSelector } from 'react-redux';
import ReactCalender from '../../common/Datepicker';
import { clearErrors } from '../../../redux/actions/error';
import { fetchDepartments } from '../../../redux/actions/api';
import { ConstantsControllerService } from '../../../services';
import apiErrorHandler from '../../../api/apiErrorHandler';

const ProhibitedForm = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { state, setState, handleSubmit, handleClear, onChangeType } = props;

    const constants = useSelector((state) => state.constants);
    const { departments } = constants;

    const {
        itemNames,
        jan,
        lines,
        classes,
        subclasses,
        selectedDepartment,
        selectedLine,
        selectedClass,
        selectedSubclass,
        lowerLimitFlag,
        deleteFlag,
        markupRateFlag,
        selectedLowestPriceType,
        prohibitedSearchType,
        startDate,
        endDate,
    } = state;

    useEffect(() => {
        dispatch(clearErrors());
        dispatch(fetchDepartments(false));
    }, [dispatch]);

    // 部門が変更された場合
    useEffect(() => {
        // ライン名、クラス名、サブクラス名をクリア
        setState((prevState) => ({
            ...prevState,

            lines: [],
            selectedLine: null,

            classes: [],
            selectedClass: null,

            subClasses: [],
            selectedSubclass: null,
        }));

        // 部門が選択されている場合のみ
        if (selectedDepartment) {
            (async () => {
                try {
                    // ライン一覧を取得
                    const response = await ConstantsControllerService.getLines([selectedDepartment.value]);
                    const lines = response.map((item) => ({
                        value: item.lineCode,
                        label: item.divisionName,
                    }));
                    handleChangeState('lines', lines);
                } catch (error) {
                    apiErrorHandler(dispatch, error);
                }
            })();
        }
    }, [dispatch, selectedDepartment]);

    // ライン名が変更された場合
    useEffect(() => {
        // クラス名、サブクラス名をクリア
        setState((prevState) => ({
            ...prevState,

            classes: [],
            selectedClass: null,

            subClasses: [],
            selectedSubclass: null,
        }));

        // ライン名が選択されている場合のみ
        if (selectedLine) {
            (async () => {
                try {
                    // クラス一覧を取得
                    const response = await ConstantsControllerService.geClasses(selectedLine.value);
                    const classes = response.map((item) => ({
                        value: item.classCode,
                        label: item.divisionName,
                        lineCode: item.lineCode,
                    }));
                    handleChangeState('classes', classes);
                } catch (error) {
                    apiErrorHandler(dispatch, error);
                }
            })();
        }
    }, [dispatch, selectedLine]);

    // クラス名が変更された場合
    useEffect(() => {
        // サブクラス名をクリア
        setState((prevState) => ({
            ...prevState,

            subClasses: [],
            selectedSubclass: null,
        }));

        // クラス名が選択されている場合のみ
        if (selectedClass) {
            (async () => {
                try {
                    // サブクラス一覧を取得
                    const response = await ConstantsControllerService.geSubclasses(selectedClass.lineCode, selectedClass.value);
                    const subclasses = response.map((item) => ({
                        value: item.subclassCode,
                        label: item.divisionName,
                    }));
                    handleChangeState('subclasses', subclasses);
                } catch (error) {
                    apiErrorHandler(dispatch, error);
                }
            })();
        }
    }, [dispatch, selectedClass]);

    const handleChangeState = (field, value) => {
        setState((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };

    const handleChangeType = (value) => {
        onChangeType(value);
    };

    return (
        <Card handleSubmit={handleSubmit} {...(prohibitedSearchType !== undefined ? { handleClear } : { type: 'none_footer' })}>
            <div className="row okc-card__row">
                {prohibitedSearchType !== undefined && (
                    <>
                        <Label
                            type="column"
                            className="col-lg-2 mb-2 mb-lg-4 form-check-label"
                            text={t('prohibited_product_list.search_form.prohibited_search_type.label')}
                        />
                        <div className="col-lg-4 mb-4" id="selling-price-type">
                            <div className="row no-gutters w-100">
                                <Choice
                                    type="radio"
                                    column="col-sm-4"
                                    id="prohibitedSearchType"
                                    onChange={(value) => {
                                        handleChangeState('prohibitedSearchType', value[0]);
                                        handleChangeType(value[0]);
                                    }}
                                    data={[
                                        {
                                            id: 'product',
                                            value: 'PRODUCT',
                                            label: t('prohibited_product_list.search_form.prohibited_search_type.product'),
                                        },
                                        {
                                            id: 'category',
                                            value: 'CATEGORY',
                                            label: t('prohibited_product_list.search_form.prohibited_search_type.category'),
                                        },
                                    ]}
                                    value={prohibitedSearchType}
                                    checked={prohibitedSearchType}
                                />
                            </div>
                        </div>
                        <Label type="column" className="col-lg-2 pl-lg-3 mb-2 mb-lg-4" />
                        <div className="col-lg-4 pr-lg-3 mb-4"></div>
                    </>
                )}
                {jan !== undefined && prohibitedSearchType == 'PRODUCT' && (
                    <>
                        <Label type="column" className="col-lg-2 mb-2 mb-lg-4" text={t('prohibited_product_list.search_form.jan.title')} />
                        <div className="col-lg-4 mb-4">
                            <Input
                                className="form-control form-control--input"
                                value={jan}
                                placeholder={t('prohibited_product_list.search_form.jan.placeholder')}
                                id="jan"
                                type="text"
                                autocomplete="off"
                                onChange={(value) => handleChangeState('jan', value)}
                            />
                        </div>
                    </>
                )}
                {itemNames !== undefined && prohibitedSearchType == 'PRODUCT' && (
                    <>
                        <Label
                            type="column"
                            className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                            text={t('prohibited_product_list.search_form.product_name.title')}
                        />
                        <div className="col-lg-4 pr-lg-3 mb-4">
                            <Input
                                className="form-control form-control--input"
                                value={itemNames}
                                placeholder={t('prohibited_product_list.search_form.product_name.placeholder')}
                                id="item-name"
                                type="text"
                                autocomplete="off"
                                onChange={(value) => handleChangeState('itemNames', value)}
                            />
                        </div>
                    </>
                )}
                <Label
                    type="column"
                    className="col-lg-2 mb-2 mb-lg-4"
                    text={t('prohibited_product_list.search_form.division.title')}
                    isRequired={prohibitedSearchType === undefined}
                />
                <div className="col-lg-4 pr-lg-3 mb-4">
                    <SelectSearch
                        isClearable={prohibitedSearchType !== undefined}
                        options={departments}
                        placeholder={t('prohibited_product_list.search_form.division.placeholder')}
                        onChange={(value) => handleChangeState('selectedDepartment', value)}
                        value={selectedDepartment?.value}
                    />
                </div>
                <Label
                    type="column"
                    className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    text={t('prohibited_product_list.search_form.line_name.title')}
                />
                <div className="col-lg-4 mb-4">
                    <SelectSearch
                        isClearable={true}
                        options={lines}
                        placeholder={t('price_registration.search_form.line_name.placeholder')}
                        onChange={(value) => handleChangeState('selectedLine', value)}
                        value={selectedLine?.value}
                        disabled={!selectedDepartment || !lines.length}
                    />
                </div>
                <Label type="column" className="col-lg-2 mb-2 mb-lg-4" text={t('prohibited_product_list.search_form.class_name.title')} />
                <div className="col-lg-4 pr-lg-3 mb-4">
                    <SelectSearch
                        isClearable={true}
                        options={classes}
                        placeholder={t('price_registration.search_form.class_name.placeholder')}
                        onChange={(value) => handleChangeState('selectedClass', value)}
                        value={selectedClass?.value}
                        disabled={!selectedLine || !classes.length}
                    />
                </div>
                <Label
                    type="column"
                    className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    text={t('prohibited_product_list.search_form.subclass_name.title')}
                />
                <div className="col-lg-4 mb-4">
                    <SelectSearch
                        isClearable={true}
                        options={subclasses}
                        placeholder={t('price_registration.search_form.subclass_name.placeholder')}
                        onChange={(value) => handleChangeState('selectedSubclass', value)}
                        value={selectedSubclass?.value}
                        disabled={!selectedClass || !subclasses.length}
                    />
                </div>
                {startDate !== undefined && prohibitedSearchType === 'PRODUCT' && (
                    <>
                        <Label
                            type="column"
                            className="col-lg-2 mb-2 mb-lg-4"
                            text={t('prohibited_product_list.search_form.start_date.title')}
                        />
                        <div className="col-lg-4 pr-lg-3 mb-4">
                            <ReactCalender
                                onChange={(value) => handleChangeState('startDate', value)}
                                value={startDate}
                                placeholder={t('prohibited_product_list.search_form.start_date.placeholder')}
                            />
                        </div>
                    </>
                )}
                {endDate !== undefined && prohibitedSearchType === 'PRODUCT' && (
                    <>
                        <Label
                            type="column"
                            className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                            text={t('prohibited_product_list.search_form.end_date.title')}
                        />
                        <div className="col-lg-4 mb-4">
                            <ReactCalender
                                onChange={(value) => handleChangeState('endDate', value)}
                                value={endDate}
                                placeholder={t('prohibited_product_list.search_form.end_date.placeholder')}
                            />
                        </div>
                    </>
                )}
                {lowerLimitFlag !== undefined && prohibitedSearchType === 'PRODUCT' && (
                    <>
                        <Label
                            type="column"
                            className="col-lg-2 mb-2 mb-lg-4 mt-lg-2 align-self-start"
                            text={t('prohibited_product_list.search_form.lower_limit.title')}
                        />
                        <div className="col-lg-4 mb-5 prohibited-products__checkboxes">
                            <div className="row m-0">
                                <Checkbox
                                    label={' '}
                                    onChange={() => handleChangeState('lowerLimitFlag', !lowerLimitFlag)}
                                    value={lowerLimitFlag}
                                    checked={lowerLimitFlag}
                                />
                            </div>
                        </div>
                    </>
                )}
                {deleteFlag !== undefined && prohibitedSearchType == 'PRODUCT' && (
                    <>
                        <Label
                            type="column"
                            className={`col-lg-2 mb-2 mb-lg-4 mt-lg-2 align-self-start ${lowerLimitFlag !== undefined ? 'pl-lg-3' : ''}`}
                            text={t('prohibited_product_list.search_form.status.title')}
                        />
                        <div className="col-lg-4 mb-4 prohibited-products__checkboxes">
                            <div className="row m-0">
                                <Checkbox
                                    column="col-xl-3 col-lg-4 col-md-5"
                                    label={t('prohibited_product_list.search_form.status.label')}
                                    onChange={() => handleChangeState('deleteFlag', !deleteFlag)}
                                    value={deleteFlag}
                                    checked={!deleteFlag} // 表示は反転させる
                                />
                            </div>
                        </div>
                    </>
                )}
                {markupRateFlag !== undefined && prohibitedSearchType === 'CATEGORY' && (
                    <>
                        <Label
                            type="column"
                            className="col-lg-2 mb-2 mb-lg-4 mt-lg-2 align-self-start"
                            text={t('prohibited_product_list.search_form.markup_rate.title')}
                        />
                        <div className="col-lg-4 mb-5 prohibited-products__checkboxes">
                            <div className="row m-0">
                                <Checkbox
                                    onChange={() => handleChangeState('markupRateFlag', !markupRateFlag)}
                                    value={markupRateFlag}
                                    checked={markupRateFlag}
                                />
                            </div>
                        </div>
                    </>
                )}
                <Label
                    type="column"
                    className={`col-lg-2 mb-2 mb-lg-4 form-check-label stop-purchase ${markupRateFlag !== undefined && prohibitedSearchType === 'CATEGORY' ? 'pl-lg-3' : ''}`}
                    text={t('prohibited_product_list.search_form.selling_price_type.title')}
                />
                <div className="col-lg-4 mb-4" id="selling-price-type">
                    <div className="row no-gutters w-100">
                        <Choice
                            type="radio"
                            column="col-sm-4"
                            onChange={(value) => handleChangeState('selectedLowestPriceType', value[0])}
                            data={[
                                {
                                    id: 'selling-price-type-competitive',
                                    value: 'COMPETITOR',
                                    label: t('prohibited_product_list.search_form.selling_price_type.competitive'),
                                },
                                {
                                    id: 'selling-price-type-freshness',
                                    value: 'FRESHNESS',
                                    label: t('prohibited_product_list.search_form.selling_price_type.freshness'),
                                },
                            ]}
                            value={selectedLowestPriceType}
                            checked={selectedLowestPriceType}
                        />
                    </div>
                </div>
            </div>
        </Card>
    );
};
export default ProhibitedForm;
